







































import { Component, PropSync, Vue } from 'vue-property-decorator';

@Component
export default class SwapCreateGroup extends Vue {
  @PropSync('ruleForm', { type: Object }) syncedRuleForm!: any;
  @PropSync('currentActive', { type: Number }) syncedCurrentActive!: number;

  public btnType: string = 'info';
  public rules: any = {
    name: [{ required: true, message: 'LAB 이름을 입력하셔야 합니다.', trigger: 'blur' }],
    organization: [
      {
        required: true,
        message: '회사명(조직)을 입력하셔야 합니다.',
        trigger: 'blur',
      },
    ],
  };

  get isNextStep(): boolean {
    let bool: boolean = true;
    if (this.syncedRuleForm.name !== '' && this.syncedRuleForm.organization !== '') {
      this.btnType = 'primary';
      bool = true;
    } else {
      this.btnType = 'info';
      bool = false;
    }
    return bool;
  }

  modalClose() {
    this.$root.$emit('closeCreateLab', false);
  }
}
